const styleSheet = () => ({
  datePickerContainer: {
    fontFamily: "'Museo Sans', sans-serif !important",
    '& .DateRangePicker': {
      borderStyle: 'solid',
      borderWidth: (props: any) =>
        props.pickerBorderWidth ? props.pickerBorderWidth : '1.5px',
      borderColor: (props: any) =>
        props.pickerColor ? props.pickerColor : '#B4E1EC',
      borderRadius: '4px !important',
      cursor: 'pointer !important',
    },
    '& .DayPickerKeyboardShortcuts_title': {
      fontSize: '14px !important',
    },
    '& .DayPickerKeyboardShortcuts_show__bottomRight::before': {
      borderRightStyle: 'solid',
      borderRightWidth: '33px',
      borderRightColor: (props: any) =>
        props.bottomRight ? props.bottomRight : '#079DC0',
    },
    '& .CalendarDay__selected': {
      background: (props: any) =>
        props.selectedBackgroundColor
          ? props.selectedBackgroundColor
          : '#079DC0',
      borderStyle: 'solid',
      borderWidth: '1.5px',
      borderColor: (props: any) =>
        props.selectedColor ? props.selectedColor : '#079DC0',
      // borderColour:"#079DC0"
    },
    '& .CalendarDay__selected_span': {
      background: (props: any) =>
        props.selectedSpanBackgroundColor
          ? props.selectedSpanBackgroundColor
          : '#9CD8E6',
      borderStyle: 'solid',
      borderWidth: '1.5px',
      borderColor: (props: any) =>
        props.selectedSpanColor ? props.selectedSpanColor : '#9CD8E6',
    },
    '& .DateRangePickerInput_arrow': {
      visibility: 'hidden',
      content: "''",
      color: (props: any) =>
        props.inputArrowColor ? props.inputArrowColor : '#079DC0',
      paddingLeft: '15px !important',
      paddingRight: '20px !important',
      verticalAlign: 'baseline !important',
      '&:after': {
        visibility: 'visible',
        // This replaces the '-' (dash) that air bnb has by default with the word 'To'
        content: "'to' !important",
        fontFamily: "'Museo Sans', sans-serif !important",
        fontSize: '12px !important',
      },
    },
    '& .DateInput': {
      cursor: 'pointer',
      width: '80px !important',
      '&:first-child': {
        '& .DateInput_input': {
          paddingLeft: '15px !important',
          paddingRight: '0px !important',
        },
      },
      '&:last-child': {
        '& .DateInput_input': {
          paddingLeft: '0px !important',
          paddingRight: '0px !important',
        },
      },
    },
    '& .DateInput_input ': {
      cursor: 'pointer',
      fontSize: '12px !important',
      color: (props: any) =>
        props.dateInputColor ? props.dateInputColor : '#079DC0',
      fontFamily: "'Museo Sans', sans-serif !important",
    },

    '& .DateInput_input__focused': {
      borderBottomWidth: '2px',
      borderBottomStyle: 'solid',
      borderBottomColor: (props: any) =>
        props.selectedColor ? props.selectedColor : '#008489',
    },
    '& .CalendarMonth_caption': {
      fontFamily: "'Museo Sans', sans-serif !important",
      fontSize: '12px !important',
    },
    '& .DateRangePickerInput__withBorder': {
      // like colour above, put in an override
      border: 'none',
      width: '100%',
    },
    '& .DayPicker_weekHeader': {
      top: '55px !important',
    },
    '& .CalendarDay': {
      fontFamily: "'Museo Sans', sans-serif !important",
      fontSize: '12px !important',
    },
    '.DateRangePickerInput': {
      display: 'flex !important',
      alignItems: 'center !important',
      justifyContent: 'center !important',
    },
  },
});

export default styleSheet;
